var _toConsumableArray = require("/Users/enricoranucci/Desktop/GitHub/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/Users/enricoranucci/Desktop/GitHub/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _createForOfIteratorHelper = require("/Users/enricoranucci/Desktop/GitHub/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
(function (h, C) {
  typeof exports == "object" && typeof module != "undefined" ? C(exports) : typeof define == "function" && define.amd ? define(["exports"], C) : (h = typeof globalThis != "undefined" ? globalThis : h || self, C(h.modernScreenshot = {}));
})(this, function (h) {
  var Ue;
  "use strict";
  var Qt = Object.defineProperty,
    Zt = Object.defineProperties;
  var er = Object.getOwnPropertyDescriptors;
  var Z = Object.getOwnPropertySymbols;
  var Le = Object.prototype.hasOwnProperty,
    Me = Object.prototype.propertyIsEnumerable;
  var Oe = Math.pow,
    Be = function Be(h, C, T) {
      return C in h ? Qt(h, C, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: T
      }) : h[C] = T;
    },
    D = function D(h, C) {
      for (var T in C || (C = {})) Le.call(C, T) && Be(h, T, C[T]);
      if (Z) {
        var _iterator = _createForOfIteratorHelper(Z(C)),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var T = _step.value;
            Me.call(C, T) && Be(h, T, C[T]);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      return h;
    },
    L = function L(h, C) {
      return Zt(h, er(C));
    };
  var We = function We(h, C) {
    var T = {};
    for (var N in h) Le.call(h, N) && C.indexOf(N) < 0 && (T[N] = h[N]);
    if (h != null && Z) {
      var _iterator2 = _createForOfIteratorHelper(Z(h)),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var N = _step2.value;
          C.indexOf(N) < 0 && Me.call(h, N) && (T[N] = h[N]);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    return T;
  };
  var E = function E(h, C, T) {
    return new Promise(function (N, M) {
      var z = function z(R) {
          try {
            W(T.next(R));
          } catch (j) {
            M(j);
          }
        },
        O = function O(R) {
          try {
            W(T.throw(R));
          } catch (j) {
            M(j);
          }
        },
        W = function W(R) {
          return R.done ? N(R.value) : Promise.resolve(R.value).then(z, O);
        };
      W((T = T.apply(h, C)).next());
    });
  };
  function C(e, t) {
    return e[13] = 1, e[14] = t >> 8, e[15] = t & 255, e[16] = t >> 8, e[17] = t & 255, e;
  }
  var T = "p".charCodeAt(0),
    N = "H".charCodeAt(0),
    M = "Y".charCodeAt(0),
    z = "s".charCodeAt(0);
  var O;
  function W() {
    var e = new Int32Array(256);
    for (var t = 0; t < 256; t++) {
      var r = t;
      for (var n = 0; n < 8; n++) r = r & 1 ? 3988292384 ^ r >>> 1 : r >>> 1;
      e[t] = r;
    }
    return e;
  }
  function R(e) {
    var t = -1;
    O || (O = W());
    for (var r = 0; r < e.length; r++) t = O[(t ^ e[r]) & 255] ^ t >>> 8;
    return t ^ -1;
  }
  function j(e) {
    var t = e.length - 1;
    for (var r = t; r >= 4; r--) if (e[r - 4] === 9 && e[r - 3] === T && e[r - 2] === N && e[r - 1] === M && e[r] === z) return r - 3;
    return 0;
  }
  function ae(e, t) {
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
    var n = new Uint8Array(13);
    t *= 39.3701, n[0] = T, n[1] = N, n[2] = M, n[3] = z, n[4] = t >>> 24, n[5] = t >>> 16, n[6] = t >>> 8, n[7] = t & 255, n[8] = n[4], n[9] = n[5], n[10] = n[6], n[11] = n[7], n[12] = 1;
    var a = R(n),
      s = new Uint8Array(4);
    if (s[0] = a >>> 24, s[1] = a >>> 16, s[2] = a >>> 8, s[3] = a & 255, r) {
      var o = j(e);
      return e.set(n, o), e.set(s, o + 13), e;
    } else {
      var _o = new Uint8Array(4);
      _o[0] = 0, _o[1] = 0, _o[2] = 0, _o[3] = 9;
      var i = new Uint8Array(54);
      return i.set(e, 0), i.set(_o, 33), i.set(n, 37), i.set(s, 50), i;
    }
  }
  var je = "AAlwSFlz",
    qe = "AAAJcEhZ",
    Ve = "AAAACXBI";
  function He(e) {
    var t = e.indexOf(je);
    return t === -1 && (t = e.indexOf(qe)), t === -1 && (t = e.indexOf(Ve)), t;
  }
  var ee = "[modern-screenshot]",
    F = typeof window != "undefined",
    ze = F && "Worker" in window,
    se = F && "atob" in window,
    Xe = F && "btoa" in window,
    te = F ? (Ue = window.navigator) == null ? void 0 : Ue.userAgent : "",
    ie = te.includes("Chrome"),
    X = te.includes("AppleWebKit") && !ie,
    re = te.includes("Firefox"),
    Ge = function Ge(e) {
      return e && "__CONTEXT__" in e;
    },
    Ye = function Ye(e) {
      return e.constructor.name === "CSSFontFaceRule";
    },
    Je = function Je(e) {
      return e.constructor.name === "CSSImportRule";
    },
    k = function k(e) {
      return e.nodeType === 1;
    },
    q = function q(e) {
      return typeof e.className == "object";
    },
    ce = function ce(e) {
      return e.tagName === "image";
    },
    Ke = function Ke(e) {
      return e.tagName === "use";
    },
    V = function V(e) {
      return k(e) && typeof e.style != "undefined" && !q(e);
    },
    Qe = function Qe(e) {
      return e.nodeType === 8;
    },
    Ze = function Ze(e) {
      return e.nodeType === 3;
    },
    _ = function _(e) {
      return e.tagName === "IMG";
    },
    G = function G(e) {
      return e.tagName === "VIDEO";
    },
    et = function et(e) {
      return e.tagName === "CANVAS";
    },
    le = function le(e) {
      return e.tagName === "TEXTAREA";
    },
    tt = function tt(e) {
      return e.tagName === "INPUT";
    },
    rt = function rt(e) {
      return e.tagName === "STYLE";
    },
    nt = function nt(e) {
      return e.tagName === "SCRIPT";
    },
    ot = function ot(e) {
      return e.tagName === "SELECT";
    },
    at = function at(e) {
      return e.tagName === "SLOT";
    },
    st = function st(e) {
      return e.tagName === "IFRAME";
    },
    A = function A() {
      var _console;
      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }
      return (_console = console).warn.apply(_console, [ee].concat(e));
    },
    it = function it(e) {
      return console.time("".concat(ee, " ").concat(e));
    },
    ct = function ct(e) {
      return console.timeEnd("".concat(ee, " ").concat(e));
    },
    lt = function lt(e) {
      var r;
      var t = (r = e == null ? void 0 : e.createElement) == null ? void 0 : r.call(e, "canvas");
      return t && (t.height = t.width = 1), t && "toDataURL" in t && Boolean(t.toDataURL("image/webp").includes("image/webp"));
    },
    ne = function ne(e) {
      return e.startsWith("data:");
    };
  function ue(e, t) {
    if (e.match(/^[a-z]+:\/\//i)) return e;
    if (F && e.match(/^\/\//)) return window.location.protocol + e;
    if (e.match(/^[a-z]+:/i) || !F) return e;
    var r = Y().implementation.createHTMLDocument(),
      n = r.createElement("base"),
      a = r.createElement("a");
    return r.head.appendChild(n), r.body.appendChild(a), t && (n.href = t), a.href = e, a.href;
  }
  function Y(e) {
    var t;
    return (t = e && k(e) ? e == null ? void 0 : e.ownerDocument : e) != null ? t : window.document;
  }
  var J = "http://www.w3.org/2000/svg";
  function fe(e, t, r) {
    var n = Y(r).createElementNS(J, "svg");
    return n.setAttributeNS(null, "width", e.toString()), n.setAttributeNS(null, "height", t.toString()), n.setAttributeNS(null, "viewBox", "0 0 ".concat(e, " ").concat(t)), n;
  }
  function de(e, t) {
    var r = new XMLSerializer().serializeToString(e);
    return t && (r = r.replace(/(?:[\0-\x08\x0B\f\x0E-\x1F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g, "")), "data:image/svg+xml;charset=utf-8,".concat(encodeURIComponent(r));
  }
  function ut(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "image/png";
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    return E(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return new Promise(function (n, a) {
              e.toBlob(function (s) {
                s ? n(s) : a(new Error("Blob is null"));
              }, t, r);
            });
          case 3:
            return _context.abrupt("return", _context.sent);
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            if (!se) {
              _context.next = 10;
              break;
            }
            return _context.abrupt("return", (A("Failed canvas to blob", {
              type: t,
              quality: r
            }, _context.t0), ft(e.toDataURL(t, r))));
          case 10:
            throw _context.t0;
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 6]]);
    }));
  }
  function ft(e) {
    var i, l;
    var _e$split = e.split(","),
      _e$split2 = _slicedToArray(_e$split, 2),
      t = _e$split2[0],
      r = _e$split2[1],
      n = (l = (i = t.match(/data:(.+);/)) == null ? void 0 : i[1]) != null ? l : void 0,
      a = window.atob(r),
      s = a.length,
      o = new Uint8Array(s);
    for (var u = 0; u < s; u += 1) o[u] = a.charCodeAt(u);
    return new Blob([o], {
      type: n
    });
  }
  function me(e, t) {
    return new Promise(function (r, n) {
      var a = new FileReader();
      a.onload = function () {
        return r(a.result);
      }, a.onerror = function () {
        return n(a.error);
      }, a.onabort = function () {
        return n(new Error("Failed read blob to ".concat(t)));
      }, t === "dataUrl" ? a.readAsDataURL(e) : t === "arrayBuffer" && a.readAsArrayBuffer(e);
    });
  }
  var dt = function dt(e) {
      return me(e, "dataUrl");
    },
    mt = function mt(e) {
      return me(e, "arrayBuffer");
    };
  function U(e, t) {
    var r = Y(t).createElement("img");
    return r.decoding = "sync", r.loading = "eager", r.src = e, r;
  }
  function $(e, t) {
    var _this = this;
    return new Promise(function (r) {
      var _ref = t != null ? t : {},
        n = _ref.timeout,
        a = _ref.ownerDocument,
        s = _ref.onError,
        o = typeof e == "string" ? U(e, Y(a)) : e;
      var i = null,
        l = null;
      function u() {
        r(o), i && clearTimeout(i), l == null || l();
      }
      if (n && (i = setTimeout(u, n)), G(o)) {
        var c = o.currentSrc || o.src;
        if (!c) return o.poster ? $(o.poster, t).then(r) : u();
        if (o.readyState >= 2) return u();
        var f = u,
          d = function d(m) {
            A("Failed video load", c, m), s == null || s(m), u();
          };
        l = function l() {
          o.removeEventListener("loadeddata", f), o.removeEventListener("error", d);
        }, o.addEventListener("loadeddata", f, {
          once: !0
        }), o.addEventListener("error", d, {
          once: !0
        });
      } else {
        var _c = ce(o) ? o.href.baseVal : o.currentSrc || o.src;
        if (!_c) return u();
        var _f = function _f() {
            return E(_this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
              return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    if (!(_(o) && "decode" in o)) {
                      _context2.next = 9;
                      break;
                    }
                    _context2.prev = 1;
                    _context2.next = 4;
                    return o.decode();
                  case 4:
                    _context2.next = 9;
                    break;
                  case 6:
                    _context2.prev = 6;
                    _context2.t0 = _context2["catch"](1);
                    A("Failed to decode image, trying to render anyway", o.dataset.originalSrc || _c, _context2.t0);
                  case 9:
                    u();
                  case 10:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2, null, [[1, 6]]);
            }));
          },
          _d = function _d(m) {
            A("Failed image load", o.dataset.originalSrc || _c, m), u();
          };
        if (_(o) && o.complete) return _f();
        l = function l() {
          o.removeEventListener("load", _f), o.removeEventListener("error", _d);
        }, o.addEventListener("load", _f, {
          once: !0
        }), o.addEventListener("error", _d, {
          once: !0
        });
      }
    });
  }
  function ge(e, t) {
    return E(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.t0 = V(e);
            if (!_context3.t0) {
              _context3.next = 9;
              break;
            }
            if (!(_(e) || G(e))) {
              _context3.next = 7;
              break;
            }
            _context3.next = 5;
            return $(e, {
              timeout: t
            });
          case 5:
            _context3.next = 9;
            break;
          case 7:
            _context3.next = 9;
            return Promise.all(["img", "video"].flatMap(function (r) {
              return Array.from(e.querySelectorAll(r)).map(function (n) {
                return $(n, {
                  timeout: t
                });
              });
            }));
          case 9:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
  }
  var he = function () {
    var t = 0;
    var r = function r() {
      return "0000".concat((Math.random() * Oe(36, 4) << 0).toString(36)).slice(-4);
    };
    return function () {
      return t += 1, "u".concat(r()).concat(t);
    };
  }();
  function we(e) {
    return e == null ? void 0 : e.split(",").map(function (t) {
      return t.trim().replace(/"|'/g, "").toLowerCase();
    }).filter(Boolean);
  }
  function gt(e) {
    return {
      time: function time(t) {
        return e && it(t);
      },
      timeEnd: function timeEnd(t) {
        return e && ct(t);
      },
      warn: function warn() {
        return e && A.apply(void 0, arguments);
      }
    };
  }
  function ht(e) {
    return {
      cache: e ? "no-cache" : "force-cache"
    };
  }
  function x(e, t) {
    return E(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", Ge(e) ? e : pe(e, L(D({}, t), {
              autoDestruct: !0
            })));
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
  }
  function pe(e, t) {
    return E(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var _this2 = this;
      var m, w, p, b, g, _ref2, _ref2$scale, r, n, _ref2$workerNumber, a, s, o, i, l, u, c, _wt, f, d;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _ref2 = t || {}, _ref2$scale = _ref2.scale, r = _ref2$scale === void 0 ? 1 : _ref2$scale, n = _ref2.workerUrl, _ref2$workerNumber = _ref2.workerNumber, a = _ref2$workerNumber === void 0 ? 1 : _ref2$workerNumber, s = Boolean(t == null ? void 0 : t.debug), o = (m = t == null ? void 0 : t.features) != null ? m : !0, i = (w = e.ownerDocument) != null ? w : F ? window.document : void 0, l = (b = (p = e.ownerDocument) == null ? void 0 : p.defaultView) != null ? b : F ? window : void 0, u = new Map(), c = L(D({
              width: 0,
              height: 0,
              quality: 1,
              type: "image/png",
              scale: r,
              backgroundColor: null,
              style: null,
              filter: null,
              maximumCanvasSize: 0,
              timeout: 3e4,
              progress: null,
              debug: s,
              fetch: D({
                requestInit: ht((g = t == null ? void 0 : t.fetch) == null ? void 0 : g.bypassingCache),
                placeholderImage: "data:image/png;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
                bypassingCache: !1
              }, t == null ? void 0 : t.fetch),
              fetchFn: null,
              font: {},
              drawImageInterval: 100,
              workerUrl: null,
              workerNumber: a,
              onCloneNode: null,
              onEmbedNode: null,
              onCreateForeignObjectSvg: null,
              includeStyleProperties: null,
              autoDestruct: !1
            }, t), {
              __CONTEXT__: !0,
              log: gt(s),
              node: e,
              ownerDocument: i,
              ownerWindow: l,
              dpi: r === 1 ? null : 96 * r,
              svgStyleElement: ye(i),
              svgDefsElement: i == null ? void 0 : i.createElementNS(J, "defs"),
              svgStyles: new Map(),
              defaultComputedStyles: new Map(),
              workers: _toConsumableArray(new Array(ze && n && a ? a : 0)).map(function () {
                try {
                  var S = new Worker(n);
                  return S.onmessage = function (y) {
                    return E(_this2, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
                      var P, _e, Q, $e, _y$data, v, I;
                      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                        while (1) switch (_context5.prev = _context5.next) {
                          case 0:
                            _y$data = y.data, v = _y$data.url, I = _y$data.result;
                            I ? (_e = (P = u.get(v)) == null ? void 0 : P.resolve) == null || _e.call(P, I) : ($e = (Q = u.get(v)) == null ? void 0 : Q.reject) == null || $e.call(Q, new Error("Error receiving message from worker: ".concat(v)));
                          case 2:
                          case "end":
                            return _context5.stop();
                        }
                      }, _callee5);
                    }));
                  }, S.onmessageerror = function (y) {
                    var I, P;
                    var v = y.data.url;
                    (P = (I = u.get(v)) == null ? void 0 : I.reject) == null || P.call(I, new Error("Error receiving message from worker: ".concat(v)));
                  }, S;
                } catch (S) {
                  return A("Failed to new Worker", S), null;
                }
              }).filter(Boolean),
              fontFamilies: new Set(),
              fontCssTexts: new Map(),
              acceptOfImage: "".concat([lt(i) && "image/webp", "image/svg+xml", "image/*", "*/*"].filter(Boolean).join(","), ";q=0.8"),
              requests: u,
              drawImageCount: 0,
              tasks: [],
              features: o,
              isEnable: function isEnable(S) {
                var y, v;
                return S === "restoreScrollPosition" ? typeof o == "boolean" ? !1 : (y = o[S]) != null ? y : !1 : typeof o == "boolean" ? o : (v = o[S]) != null ? v : !0;
              }
            });
            c.log.time("wait until load");
            _context6.next = 4;
            return ge(e, c.timeout);
          case 4:
            c.log.timeEnd("wait until load");
            _wt = wt(e, c), f = _wt.width, d = _wt.height;
            return _context6.abrupt("return", (c.width = f, c.height = d, c));
          case 7:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
  }
  function ye(e) {
    if (!e) return;
    var t = e.createElement("style"),
      r = t.ownerDocument.createTextNode("\n.______background-clip--text {\n  background-clip: text;\n  -webkit-background-clip: text;\n}\n");
    return t.appendChild(r), t;
  }
  function wt(e, t) {
    var r = t.width,
      n = t.height;
    if (k(e) && (!r || !n)) {
      var a = e.getBoundingClientRect();
      r = r || a.width || Number(e.getAttribute("width")) || 0, n = n || a.height || Number(e.getAttribute("height")) || 0;
    }
    return {
      width: r,
      height: n
    };
  }
  function pt(e, t) {
    return E(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      var r, n, a, s, o, _yt, i, l, u, _loop, c;
      return _regeneratorRuntime().wrap(function _callee7$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            r = t.log, n = t.timeout, a = t.drawImageCount, s = t.drawImageInterval;
            r.time("image to canvas");
            _context8.next = 4;
            return $(e, {
              timeout: n
            });
          case 4:
            o = _context8.sent;
            _yt = yt(e.ownerDocument, t);
            i = _yt.canvas;
            l = _yt.context2d;
            u = function u() {
              try {
                l == null || l.drawImage(o, 0, 0, i.width, i.height);
              } catch (c) {
                A("Failed to drawImage", c);
              }
            };
            if (!(u(), t.isEnable("fixSvgXmlDecode"))) {
              _context8.next = 17;
              break;
            }
            _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop(c) {
              return _regeneratorRuntime().wrap(function _loop$(_context7) {
                while (1) switch (_context7.prev = _context7.next) {
                  case 0:
                    _context7.next = 2;
                    return new Promise(function (f) {
                      setTimeout(function () {
                        u(), f();
                      }, c + s);
                    });
                  case 2:
                  case "end":
                    return _context7.stop();
                }
              }, _loop);
            });
            c = 0;
          case 12:
            if (!(c < a)) {
              _context8.next = 17;
              break;
            }
            return _context8.delegateYield(_loop(c), "t0", 14);
          case 14:
            c++;
            _context8.next = 12;
            break;
          case 17:
            return _context8.abrupt("return", (t.drawImageCount = 0, r.timeEnd("image to canvas"), i));
          case 18:
          case "end":
            return _context8.stop();
        }
      }, _callee7);
    }));
  }
  function yt(e, t) {
    var r = t.width,
      n = t.height,
      a = t.scale,
      s = t.backgroundColor,
      o = t.maximumCanvasSize,
      i = e.createElement("canvas");
    i.width = Math.floor(r * a), i.height = Math.floor(n * a), i.style.width = "".concat(r, "px"), i.style.height = "".concat(n, "px"), o && (i.width > o || i.height > o) && (i.width > o && i.height > o ? i.width > i.height ? (i.height *= o / i.width, i.width = o) : (i.width *= o / i.height, i.height = o) : i.width > o ? (i.height *= o / i.width, i.width = o) : (i.width *= o / i.height, i.height = o));
    var l = i.getContext("2d");
    return l && s && (l.fillStyle = s, l.fillRect(0, 0, i.width, i.height)), {
      canvas: i,
      context2d: l
    };
  }
  var bt = ["width", "height", "-webkit-text-fill-color"],
    St = ["stroke", "fill"];
  function be(e, t, r) {
    var b;
    var n = r.defaultComputedStyles,
      a = r.ownerDocument,
      s = e.nodeName.toLowerCase(),
      o = q(e) && s !== "svg",
      i = o ? St.map(function (g) {
        return [g, e.getAttribute(g)];
      }).filter(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          g = _ref4[1];
        return g !== null;
      }) : [],
      l = [o && "svg", s, i.map(function (g, S) {
        return "".concat(g, "=").concat(S);
      }).join(","), t].filter(Boolean).join(":");
    if (n.has(l)) return n.get(l);
    var u = r.sandbox;
    if (!u) try {
      a && (u = a.createElement("iframe"), u.id = "__SANDBOX__-".concat(he()), u.width = "0", u.height = "0", u.style.visibility = "hidden", u.style.position = "fixed", a.body.appendChild(u), (b = u.contentWindow) == null || b.document.write('<!DOCTYPE html><meta charset="UTF-8"><title></title><body>'), r.sandbox = u);
    } catch (g) {
      A("Failed to create iframe sandbox", g);
    }
    if (!u) return new Map();
    var c = u.contentWindow;
    if (!c) return new Map();
    var f = c.document;
    var d, m;
    o ? (d = f.createElementNS(J, "svg"), m = d.ownerDocument.createElementNS(d.namespaceURI, s), i.forEach(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
        g = _ref6[0],
        S = _ref6[1];
      m.setAttributeNS(null, g, S);
    }), d.appendChild(m)) : d = m = f.createElement(s), m.textContent = " ", f.body.appendChild(d);
    var w = c.getComputedStyle(m, t),
      p = new Map();
    for (var g = w.length, S = 0; S < g; S++) {
      var y = w.item(S);
      bt.includes(y) || p.set(y, w.getPropertyValue(y));
    }
    return f.body.removeChild(d), n.set(l, p), p;
  }
  function Se(e, t, r) {
    var i;
    var n = new Map(),
      a = [],
      s = new Map();
    if (r) {
      var _iterator3 = _createForOfIteratorHelper(r),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _l = _step3.value;
          o(_l);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    } else for (var _l2 = e.length, u = 0; u < _l2; u++) {
      var c = e.item(u);
      o(c);
    }
    for (var _l3 = a.length, _u = 0; _u < _l3; _u++) (i = s.get(a[_u])) == null || i.forEach(function (c, f) {
      return n.set(f, c);
    });
    function o(l) {
      var u = e.getPropertyValue(l),
        c = e.getPropertyPriority(l),
        f = l.lastIndexOf("-"),
        d = f > -1 ? l.substring(0, f) : void 0;
      if (d) {
        var m = s.get(d);
        m || (m = new Map(), s.set(d, m)), m.set(l, [u, c]);
      }
      t.get(l) === u && !c || (d ? a.push(d) : n.set(l, [u, c]));
    }
    return n;
  }
  var Et = [":before", ":after"],
    Ct = [":-webkit-scrollbar", ":-webkit-scrollbar-button", ":-webkit-scrollbar-thumb", ":-webkit-scrollbar-track", ":-webkit-scrollbar-track-piece", ":-webkit-scrollbar-corner", ":-webkit-resizer"];
  function Tt(e, t, r, n) {
    var a = n.ownerWindow,
      s = n.svgStyleElement,
      o = n.svgStyles,
      i = n.currentNodeStyle;
    if (!s || !a) return;
    function l(u) {
      var S;
      var c = a.getComputedStyle(e, u);
      var f = c.getPropertyValue("content");
      if (!f || f === "none") return;
      f = f.replace(/(')|(")|(counter\(.+\))/g, "");
      var d = [he()],
        m = be(e, u, n);
      i == null || i.forEach(function (y, v) {
        m.delete(v);
      });
      var w = Se(c, m, n.includeStyleProperties);
      w.delete("content"), w.delete("-webkit-locale"), ((S = w.get("background-clip")) == null ? void 0 : S[0]) === "text" && t.classList.add("______background-clip--text");
      var p = ["content: '".concat(f, "';")];
      if (w.forEach(function (_ref7, I) {
        var _ref8 = _slicedToArray(_ref7, 2),
          y = _ref8[0],
          v = _ref8[1];
        p.push("".concat(I, ": ").concat(y).concat(v ? " !important" : "", ";"));
      }), p.length === 1) return;
      try {
        t.className = [t.className].concat(d).join(" ");
      } catch (y) {
        return;
      }
      var b = p.join("\n  ");
      var g = o.get(b);
      g || (g = [], o.set(b, g)), g.push(".".concat(d[0], ":").concat(u));
    }
    Et.forEach(l), r && Ct.forEach(l);
  }
  function vt(e, t) {
    le(e) && (t.innerHTML = e.value), (le(e) || tt(e) || ot(e)) && t.setAttribute("value", e.value);
  }
  function At(e, t, r, n) {
    var f, d, m, w;
    var a = n.ownerWindow,
      s = n.includeStyleProperties,
      o = n.currentParentNodeStyle,
      i = t.style,
      l = a.getComputedStyle(e),
      u = be(e, null, n);
    o == null || o.forEach(function (p, b) {
      u.delete(b);
    });
    var c = Se(l, u, s);
    return c.delete("transition-property"), c.delete("all"), c.delete("d"), c.delete("content"), r && (c.delete("margin-top"), c.delete("margin-right"), c.delete("margin-bottom"), c.delete("margin-left"), c.delete("margin-block-start"), c.delete("margin-block-end"), c.delete("margin-inline-start"), c.delete("margin-inline-end"), c.set("box-sizing", ["border-box", ""])), ((f = c.get("background-clip")) == null ? void 0 : f[0]) === "text" && t.classList.add("______background-clip--text"), ie && (c.has("font-kerning") || c.set("font-kerning", ["normal", ""]), (((d = c.get("overflow-x")) == null ? void 0 : d[0]) === "hidden" || ((m = c.get("overflow-y")) == null ? void 0 : m[0]) === "hidden") && ((w = c.get("text-overflow")) == null ? void 0 : w[0]) === "ellipsis" && e.scrollWidth === e.clientWidth && c.set("text-overflow", ["clip", ""])), c.forEach(function (_ref9, g) {
      var _ref10 = _slicedToArray(_ref9, 2),
        p = _ref10[0],
        b = _ref10[1];
      i.setProperty(g, p, b);
    }), c;
  }
  function Nt(e, t) {
    var r;
    try {
      if ((r = e == null ? void 0 : e.contentDocument) != null && r.body) return oe(e.contentDocument.body, t);
    } catch (n) {
      A("Failed to clone iframe", n);
    }
    return e.cloneNode(!1);
  }
  function Ee(e) {
    if (e.ownerDocument) try {
      var a = e.toDataURL();
      if (a !== "data:,") return U(a, e.ownerDocument);
    } catch (a) {}
    var t = e.cloneNode(!1),
      r = e.getContext("2d"),
      n = t.getContext("2d");
    try {
      return r && n && n.putImageData(r.getImageData(0, 0, e.width, e.height), 0, 0), t;
    } catch (a) {
      A("Failed to clone canvas", a);
    }
    return t;
  }
  function It(e) {
    return E(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
      var t, r, n, a, s;
      return _regeneratorRuntime().wrap(function _callee8$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            if (!(e.ownerDocument && !e.currentSrc && e.poster)) {
              _context9.next = 2;
              break;
            }
            return _context9.abrupt("return", U(e.poster, e.ownerDocument));
          case 2:
            t = e.cloneNode(!1);
            t.crossOrigin = "anonymous", e.currentSrc && e.currentSrc !== e.src && (t.src = e.currentSrc);
            r = t.ownerDocument;
            if (!r) {
              _context9.next = 25;
              break;
            }
            n = !0;
            _context9.next = 9;
            return $(t, {
              onError: function onError() {
                return n = !1;
              }
            });
          case 9:
            if (n) {
              _context9.next = 11;
              break;
            }
            return _context9.abrupt("return", e.poster ? U(e.poster, e.ownerDocument) : t);
          case 11:
            t.currentTime = e.currentTime;
            _context9.next = 14;
            return new Promise(function (s) {
              t.addEventListener("seeked", s, {
                once: !0
              });
            });
          case 14:
            a = r.createElement("canvas");
            a.width = e.offsetWidth, a.height = e.offsetHeight;
            _context9.prev = 16;
            s = a.getContext("2d");
            s && s.drawImage(t, 0, 0, a.width, a.height);
            _context9.next = 24;
            break;
          case 21:
            _context9.prev = 21;
            _context9.t0 = _context9["catch"](16);
            return _context9.abrupt("return", (A("Failed to clone video", _context9.t0), e.poster ? U(e.poster, e.ownerDocument) : t));
          case 24:
            return _context9.abrupt("return", Ee(a));
          case 25:
            return _context9.abrupt("return", t);
          case 26:
          case "end":
            return _context9.stop();
        }
      }, _callee8, null, [[16, 21]]);
    }));
  }
  function kt(e) {
    var t = e.cloneNode(!1);
    return e.currentSrc && e.currentSrc !== e.src && (t.src = e.currentSrc, t.srcset = ""), t.loading === "lazy" && (t.loading = "eager"), t;
  }
  function xt(e, t) {
    return et(e) ? Ee(e) : st(e) ? Nt(e, t) : _(e) ? kt(e) : G(e) ? It(e) : e.cloneNode(!1);
  }
  var Ce = new Set(["symbol"]);
  function Te(e, t, r, n) {
    return E(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
      var a;
      return _regeneratorRuntime().wrap(function _callee9$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            if (!(k(r) && (rt(r) || nt(r)) || n.filter && !n.filter(r))) {
              _context10.next = 2;
              break;
            }
            return _context10.abrupt("return");
          case 2:
            Ce.has(t.nodeName) || Ce.has(r.nodeName) ? n.currentParentNodeStyle = void 0 : n.currentParentNodeStyle = n.currentNodeStyle;
            _context10.next = 5;
            return oe(r, n);
          case 5:
            a = _context10.sent;
            n.isEnable("restoreScrollPosition") && Dt(e, a), t.appendChild(a);
          case 7:
          case "end":
            return _context10.stop();
        }
      }, _callee9);
    }));
  }
  function ve(e, t, r) {
    return E(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
      var a, s, n, _o2, _i, _l4;
      return _regeneratorRuntime().wrap(function _callee10$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            n = (s = k(e) ? (a = e.shadowRoot) == null ? void 0 : a.firstChild : void 0) != null ? s : e.firstChild;
            _o2 = n;
          case 2:
            if (!_o2) {
              _context11.next = 20;
              break;
            }
            if (Qe(_o2)) {
              _context11.next = 17;
              break;
            }
            if (!(k(_o2) && at(_o2) && typeof _o2.assignedNodes == "function")) {
              _context11.next = 15;
              break;
            }
            _i = _o2.assignedNodes();
            _l4 = 0;
          case 7:
            if (!(_l4 < _i.length)) {
              _context11.next = 13;
              break;
            }
            _context11.next = 10;
            return Te(e, t, _i[_l4], r);
          case 10:
            _l4++;
            _context11.next = 7;
            break;
          case 13:
            _context11.next = 17;
            break;
          case 15:
            _context11.next = 17;
            return Te(e, t, _o2, r);
          case 17:
            _o2 = _o2.nextSibling;
            _context11.next = 2;
            break;
          case 20:
          case "end":
            return _context11.stop();
        }
      }, _callee10);
    }));
  }
  function Dt(e, t) {
    if (!V(e) || !V(t)) return;
    var r = e.scrollTop,
      n = e.scrollLeft;
    if (!r && !n) return;
    var a = t.style.transform,
      s = new DOMMatrix(a),
      o = s.a,
      i = s.b,
      l = s.c,
      u = s.d;
    s.a = 1, s.b = 0, s.c = 0, s.d = 1, s.translateSelf(-n, -r), s.a = o, s.b = i, s.c = l, s.d = u, t.style.transform = s.toString();
  }
  function Rt(e, t) {
    var r = t.backgroundColor,
      n = t.width,
      a = t.height,
      s = t.style,
      o = e.style;
    if (r && o.setProperty("background-color", r, "important"), n && o.setProperty("width", "".concat(n, "px"), "important"), a && o.setProperty("height", "".concat(a, "px"), "important"), s) for (var _i2 in s) o[_i2] = s[_i2];
  }
  var Pt = /^[\w-:]+$/;
  function oe(e, t) {
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
    return E(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
      var i, l, u, c, n, a, s, f, w, p, b, g, d, m, _w, o;
      return _regeneratorRuntime().wrap(function _callee11$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            n = t.ownerDocument, a = t.ownerWindow, s = t.fontFamilies;
            if (!(n && Ze(e))) {
              _context12.next = 3;
              break;
            }
            return _context12.abrupt("return", n.createTextNode(e.data));
          case 3:
            if (!(n && a && k(e) && (V(e) || q(e)))) {
              _context12.next = 20;
              break;
            }
            _context12.next = 6;
            return xt(e, t);
          case 6:
            f = _context12.sent;
            if (t.isEnable("removeAbnormalAttributes")) {
              w = f.getAttributeNames();
              for (p = w.length, b = 0; b < p; b++) {
                g = w[b];
                Pt.test(g) || f.removeAttribute(g);
              }
            }
            d = t.currentNodeStyle = At(e, f, r, t);
            r && Rt(f, t);
            m = !1;
            if (t.isEnable("copyScrollbar")) {
              _w = [(i = d.get("overflow-x")) == null ? void 0 : i[0], (l = d.get("overflow-y")) == null ? void 0 : l[1]];
              m = _w.includes("scroll") || (_w.includes("auto") || _w.includes("overlay")) && (e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth);
            }
            Tt(e, f, m, t);
            vt(e, f);
            (c = we((u = d.get("font-family")) == null ? void 0 : u[0])) == null || c.forEach(function (w) {
              return s.add(w);
            });
            _context12.t0 = G(e);
            if (_context12.t0) {
              _context12.next = 19;
              break;
            }
            _context12.next = 19;
            return ve(e, f, t);
          case 19:
            return _context12.abrupt("return", f);
          case 20:
            o = e.cloneNode(!1);
            _context12.next = 23;
            return ve(e, o, t);
          case 23:
            return _context12.abrupt("return", o);
          case 24:
          case "end":
            return _context12.stop();
        }
      }, _callee11);
    }));
  }
  function Ae(e) {
    if (e.ownerDocument = void 0, e.ownerWindow = void 0, e.svgStyleElement = void 0, e.svgDefsElement = void 0, e.svgStyles.clear(), e.defaultComputedStyles.clear(), e.sandbox) {
      try {
        e.sandbox.remove();
      } catch (t) {}
      e.sandbox = void 0;
    }
    e.workers = [], e.fontFamilies.clear(), e.fontCssTexts.clear(), e.requests.clear(), e.tasks = [];
  }
  function Ft(e) {
    var i = e,
      t = i.url,
      r = i.timeout,
      n = i.responseType,
      a = We(i, ["url", "timeout", "responseType"]),
      s = new AbortController(),
      o = r ? setTimeout(function () {
        return s.abort();
      }, r) : void 0;
    return fetch(t, D({
      signal: s.signal
    }, a)).then(function (l) {
      if (!l.ok) throw new Error("Failed fetch, not 2xx response", {
        cause: l
      });
      switch (n) {
        case "dataUrl":
          return l.blob().then(dt);
        case "text":
        default:
          return l.text();
      }
    }).finally(function () {
      return clearTimeout(o);
    });
  }
  function H(e, t) {
    var _this3 = this;
    var r = t.url,
      _t$requestType = t.requestType,
      n = _t$requestType === void 0 ? "text" : _t$requestType,
      _t$responseType = t.responseType,
      a = _t$responseType === void 0 ? "text" : _t$responseType,
      s = t.imageDom;
    var o = r;
    var i = e.timeout,
      l = e.acceptOfImage,
      u = e.requests,
      c = e.fetchFn,
      _e$fetch = e.fetch,
      f = _e$fetch.requestInit,
      d = _e$fetch.bypassingCache,
      m = _e$fetch.placeholderImage,
      w = e.workers;
    n === "image" && (X || re) && e.drawImageCount++;
    var p = u.get(r);
    if (!p) {
      d && d instanceof RegExp && d.test(o) && (o += (/\?/.test(o) ? "&" : "?") + new Date().getTime());
      var b = D({
        url: o,
        timeout: i,
        responseType: a,
        headers: n === "image" ? {
          accept: l
        } : void 0
      }, f);
      p = {
        type: n,
        resolve: void 0,
        reject: void 0,
        response: null
      }, p.response = function () {
        return E(_this3, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
          var g;
          return _regeneratorRuntime().wrap(function _callee12$(_context13) {
            while (1) switch (_context13.prev = _context13.next) {
              case 0:
                if (!(c && n === "image")) {
                  _context13.next = 6;
                  break;
                }
                _context13.next = 3;
                return c(r);
              case 3:
                g = _context13.sent;
                if (!g) {
                  _context13.next = 6;
                  break;
                }
                return _context13.abrupt("return", g);
              case 6:
                return _context13.abrupt("return", !X && r.startsWith("http") && w.length ? new Promise(function (g, S) {
                  w[u.size & w.length - 1].postMessage(D({
                    rawUrl: r
                  }, b)), p.resolve = g, p.reject = S;
                }) : Ft(b));
              case 7:
              case "end":
                return _context13.stop();
            }
          }, _callee12);
        }));
      }().catch(function (g) {
        if (u.delete(r), n === "image" && m) return A("Failed to fetch image base64, trying to use placeholder image", o), typeof m == "string" ? m : m(s);
        throw g;
      }), u.set(r, p);
    }
    return p.response;
  }
  function Ne(e, t, r, n) {
    return E(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
      var _iterator4, _step4, _step4$value, a, s, _o3;
      return _regeneratorRuntime().wrap(function _callee13$(_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            if (Ie(e)) {
              _context14.next = 2;
              break;
            }
            return _context14.abrupt("return", e);
          case 2:
            _iterator4 = _createForOfIteratorHelper(Ut(e, t));
            _context14.prev = 3;
            _iterator4.s();
          case 5:
            if ((_step4 = _iterator4.n()).done) {
              _context14.next = 19;
              break;
            }
            _step4$value = _slicedToArray(_step4.value, 2), a = _step4$value[0], s = _step4$value[1];
            _context14.prev = 7;
            _context14.next = 10;
            return H(r, {
              url: s,
              requestType: n ? "image" : "text",
              responseType: "dataUrl"
            });
          case 10:
            _o3 = _context14.sent;
            e = e.replace(_t(a), "$1".concat(_o3, "$3"));
            _context14.next = 17;
            break;
          case 14:
            _context14.prev = 14;
            _context14.t0 = _context14["catch"](7);
            A("Failed to fetch css data url", a, _context14.t0);
          case 17:
            _context14.next = 5;
            break;
          case 19:
            _context14.next = 24;
            break;
          case 21:
            _context14.prev = 21;
            _context14.t1 = _context14["catch"](3);
            _iterator4.e(_context14.t1);
          case 24:
            _context14.prev = 24;
            _iterator4.f();
            return _context14.finish(24);
          case 27:
            return _context14.abrupt("return", e);
          case 28:
          case "end":
            return _context14.stop();
        }
      }, _callee13, null, [[3, 21, 24, 27], [7, 14]]);
    }));
  }
  function Ie(e) {
    return /url\((['"]?)([^'"]+?)\1\)/.test(e);
  }
  var ke = /url\((['"]?)([^'"]+?)\1\)/g;
  function Ut(e, t) {
    var r = [];
    return e.replace(ke, function (n, a, s) {
      return r.push([s, ue(s, t)]), n;
    }), r.filter(function (_ref11) {
      var _ref12 = _slicedToArray(_ref11, 1),
        n = _ref12[0];
      return !ne(n);
    });
  }
  function _t(e) {
    var t = e.replace(/([.*+?^${}()|\[\]\/\\])/g, "\\$1");
    return new RegExp("(url\\(['\"]?)(".concat(t, ")(['\"]?\\))"), "g");
  }
  function $t(e, t) {
    return E(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
      var _this4 = this;
      var r, n, a, s, o, i, _l5, _l6;
      return _regeneratorRuntime().wrap(function _callee15$(_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            r = t.ownerDocument, n = t.svgStyleElement, a = t.fontFamilies, s = t.fontCssTexts, o = t.tasks, i = t.font;
            if (!r || !n || !a.size) {
              _context16.next = 11;
              break;
            }
            if (!(i && i.cssText)) {
              _context16.next = 7;
              break;
            }
            _l5 = De(i.cssText, t);
            n.appendChild(r.createTextNode("".concat(_l5, "\n")));
            _context16.next = 11;
            break;
          case 7:
            _l6 = Array.from(r.styleSheets).filter(function (c) {
              try {
                return "cssRules" in c && Boolean(c.cssRules.length);
              } catch (f) {
                return A("Error while reading CSS rules from ".concat(c.href), f), !1;
              }
            });
            _context16.next = 10;
            return Promise.all(_l6.flatMap(function (c) {
              return Array.from(c.cssRules).map(function (f, d) {
                return E(_this4, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
                  var m, w, p, b, _iterator5, _step5, g;
                  return _regeneratorRuntime().wrap(function _callee14$(_context15) {
                    while (1) switch (_context15.prev = _context15.next) {
                      case 0:
                        if (!Je(f)) {
                          _context15.next = 16;
                          break;
                        }
                        m = d + 1;
                        w = f.href;
                        p = "";
                        _context15.prev = 4;
                        _context15.next = 7;
                        return H(t, {
                          url: w,
                          requestType: "text",
                          responseType: "text"
                        });
                      case 7:
                        p = _context15.sent;
                        _context15.next = 13;
                        break;
                      case 10:
                        _context15.prev = 10;
                        _context15.t0 = _context15["catch"](4);
                        A("Error fetch remote css import from ".concat(w), _context15.t0);
                      case 13:
                        b = p.replace(ke, function (g, S, y) {
                          return g.replace(y, ue(y, w));
                        });
                        _iterator5 = _createForOfIteratorHelper(Lt(b));
                        try {
                          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                            g = _step5.value;
                            try {
                              c.insertRule(g, g.startsWith("@import") ? m += 1 : c.cssRules.length);
                            } catch (S) {
                              A("Error inserting rule from remote css import", {
                                rule: g,
                                error: S
                              });
                            }
                          }
                        } catch (err) {
                          _iterator5.e(err);
                        } finally {
                          _iterator5.f();
                        }
                      case 16:
                      case "end":
                        return _context15.stop();
                    }
                  }, _callee14, null, [[4, 10]]);
                }));
              });
            }));
          case 10:
            _l6.flatMap(function (c) {
              return Array.from(c.cssRules);
            }).filter(function (c) {
              var f;
              return Ye(c) && Ie(c.style.getPropertyValue("src")) && ((f = we(c.style.getPropertyValue("font-family"))) == null ? void 0 : f.some(function (d) {
                return a.has(d);
              }));
            }).forEach(function (c) {
              var f = c,
                d = s.get(f.cssText);
              d ? n.appendChild(r.createTextNode("".concat(d, "\n"))) : o.push(Ne(f.cssText, f.parentStyleSheet ? f.parentStyleSheet.href : null, t).then(function (m) {
                m = De(m, t), s.set(f.cssText, m), n.appendChild(r.createTextNode("".concat(m, "\n")));
              }));
            });
          case 11:
          case "end":
            return _context16.stop();
        }
      }, _callee15);
    }));
  }
  var Bt = /(\/\*[\s\S]*?\*\/)/gi,
    xe = /((@.*?keyframes [\s\S]*?){([\s\S]*?}\s*?)})/gi;
  function Lt(e) {
    if (e == null) return [];
    var t = [];
    var r = e.replace(Bt, "");
    for (;;) {
      var s = xe.exec(r);
      if (!s) break;
      t.push(s[0]);
    }
    r = r.replace(xe, "");
    var n = /@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi,
      a = new RegExp("((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})", "gi");
    for (;;) {
      var _s = n.exec(r);
      if (_s) a.lastIndex = n.lastIndex;else if (_s = a.exec(r), _s) n.lastIndex = a.lastIndex;else break;
      t.push(_s[0]);
    }
    return t;
  }
  var Mt = /url\([^)]+\)\s*format\((["']?)([^"']+)\1\)/g,
    Ot = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;
  function De(e, t) {
    var r = t.font,
      n = r ? r == null ? void 0 : r.preferredFormat : void 0;
    return n ? e.replace(Ot, function (a) {
      for (;;) {
        var _ref13 = Mt.exec(a) || [],
          _ref14 = _slicedToArray(_ref13, 3),
          s = _ref14[0],
          _o4 = _ref14[2];
        if (!_o4) return "";
        if (_o4 === n) return "src: ".concat(s, ";");
      }
    }) : e;
  }
  function Wt(e, t) {
    if (_(e)) {
      var r = e.currentSrc || e.src;
      if (!ne(r)) return [H(t, {
        url: r,
        imageDom: e,
        requestType: "image",
        responseType: "dataUrl"
      }).then(function (n) {
        n && (e.srcset = "", e.dataset.originalSrc = r, e.src = n || "");
      })];
      (X || re) && t.drawImageCount++;
    } else if (q(e) && !ne(e.href.baseVal)) {
      var _r = e.href.baseVal;
      return [H(t, {
        url: _r,
        imageDom: e,
        requestType: "image",
        responseType: "dataUrl"
      }).then(function (n) {
        n && (e.dataset.originalSrc = _r, e.href.baseVal = n || "");
      })];
    }
    return [];
  }
  var jt = ["background-image", "border-image-source", "-webkit-border-image", "-webkit-mask-image", "list-style-image"];
  function qt(e, t) {
    return jt.map(function (r) {
      var n = e.getPropertyValue(r);
      return !n || n === "none" ? null : ((X || re) && t.drawImageCount++, Ne(n, null, t, !0).then(function (a) {
        !a || n === a || e.setProperty(r, a, e.getPropertyPriority(r));
      }));
    }).filter(Boolean);
  }
  function Vt(e, t) {
    var i;
    var r = t.ownerDocument,
      n = t.svgDefsElement,
      a = (i = e.getAttribute("href")) != null ? i : e.getAttribute("xlink:href");
    if (!a) return [];
    var _a$split = a.split("#"),
      _a$split2 = _slicedToArray(_a$split, 2),
      s = _a$split2[0],
      o = _a$split2[1];
    if (o) {
      var _l7 = "#".concat(o),
        u = r == null ? void 0 : r.querySelector("svg ".concat(_l7));
      if (s && e.setAttribute("href", _l7), n != null && n.querySelector(_l7)) return [];
      if (u) return n == null || n.appendChild(u.cloneNode(!0)), [];
      if (s) return [H(t, {
        url: s,
        responseType: "text"
      }).then(function (c) {
        n == null || n.insertAdjacentHTML("beforeend", c);
      })];
    }
    return [];
  }
  function Re(e, t) {
    var r = t.tasks;
    k(e) && ((_(e) || ce(e)) && r.push.apply(r, _toConsumableArray(Wt(e, t))), Ke(e) && r.push.apply(r, _toConsumableArray(Vt(e, t)))), V(e) && r.push.apply(r, _toConsumableArray(qt(e.style, t))), e.childNodes.forEach(function (n) {
      Re(n, t);
    });
  }
  function Pe(e, t) {
    return E(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
      var _this5 = this;
      var r, n, a, s, o, i, l, u, c, f, d, m, w, p, v, b, g, S, y;
      return _regeneratorRuntime().wrap(function _callee17$(_context18) {
        while (1) switch (_context18.prev = _context18.next) {
          case 0:
            _context18.next = 2;
            return x(e, t);
          case 2:
            r = _context18.sent;
            if (!(k(r.node) && q(r.node))) {
              _context18.next = 5;
              break;
            }
            return _context18.abrupt("return", r.node);
          case 5:
            n = r.ownerDocument, a = r.log, s = r.tasks, o = r.svgStyleElement, i = r.svgDefsElement, l = r.svgStyles, u = r.font, c = r.progress, f = r.autoDestruct, d = r.onCloneNode, m = r.onEmbedNode, w = r.onCreateForeignObjectSvg;
            a.time("clone node");
            _context18.next = 9;
            return oe(r.node, r, !0);
          case 9:
            p = _context18.sent;
            if (o && n) {
              v = "";
              l.forEach(function (I, P) {
                v += "".concat(I.join(",\n"), " {\n  ").concat(P, "\n}\n");
              }), o.appendChild(n.createTextNode(v));
            }
            a.timeEnd("clone node");
            d == null || d(p);
            _context18.t0 = u !== !1 && k(p);
            if (!_context18.t0) {
              _context18.next = 19;
              break;
            }
            a.time("embed web font");
            _context18.next = 18;
            return $t(p, r);
          case 18:
            a.timeEnd("embed web font");
          case 19:
            a.time("embed node");
            Re(p, r);
            b = s.length;
            g = 0;
            S = function S() {
              return E(_this5, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
                var _v;
                return _regeneratorRuntime().wrap(function _callee16$(_context17) {
                  while (1) switch (_context17.prev = _context17.next) {
                    case 0:
                      _v = s.pop();
                      if (_v) {
                        _context17.next = 3;
                        break;
                      }
                      return _context17.abrupt("break", 14);
                    case 3:
                      _context17.prev = 3;
                      _context17.next = 6;
                      return _v;
                    case 6:
                      _context17.next = 11;
                      break;
                    case 8:
                      _context17.prev = 8;
                      _context17.t0 = _context17["catch"](3);
                      A("Failed to run task", _context17.t0);
                    case 11:
                      c == null || c(++g, b);
                    case 12:
                      _context17.next = 0;
                      break;
                    case 14:
                    case "end":
                      return _context17.stop();
                  }
                }, _callee16, null, [[3, 8]]);
              }));
            };
            c == null || c(g, b);
            _context18.next = 27;
            return Promise.all(_toConsumableArray(Array(4)).map(S));
          case 27:
            a.timeEnd("embed node");
            m == null || m(p);
            y = Ht(p, r);
            return _context18.abrupt("return", (i && y.insertBefore(i, y.children[0]), o && y.insertBefore(o, y.children[0]), f && Ae(r), w == null || w(y), y));
          case 31:
          case "end":
            return _context18.stop();
        }
      }, _callee17);
    }));
  }
  function Ht(e, t) {
    var r = t.width,
      n = t.height,
      a = fe(r, n, e.ownerDocument),
      s = a.ownerDocument.createElementNS(a.namespaceURI, "foreignObject");
    return s.setAttributeNS(null, "x", "0%"), s.setAttributeNS(null, "y", "0%"), s.setAttributeNS(null, "width", "100%"), s.setAttributeNS(null, "height", "100%"), s.append(e), a.appendChild(s), a;
  }
  function K(e, t) {
    return E(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
      var o, r, n, a, s;
      return _regeneratorRuntime().wrap(function _callee18$(_context19) {
        while (1) switch (_context19.prev = _context19.next) {
          case 0:
            _context19.next = 2;
            return x(e, t);
          case 2:
            r = _context19.sent;
            _context19.next = 5;
            return Pe(r);
          case 5:
            n = _context19.sent;
            a = de(n, r.isEnable("removeControlCharacter"));
            r.autoDestruct || (r.svgStyleElement = ye(r.ownerDocument), r.svgDefsElement = (o = r.ownerDocument) == null ? void 0 : o.createElementNS(J, "defs"), r.svgStyles.clear());
            s = U(a, n.ownerDocument);
            _context19.next = 11;
            return pt(s, r);
          case 11:
            return _context19.abrupt("return", _context19.sent);
          case 12:
          case "end":
            return _context19.stop();
        }
      }, _callee18);
    }));
  }
  function zt(e, t) {
    return E(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
      var r, n, a, s, o, i, l, u, _c2;
      return _regeneratorRuntime().wrap(function _callee19$(_context20) {
        while (1) switch (_context20.prev = _context20.next) {
          case 0:
            _context20.next = 2;
            return x(e, t);
          case 2:
            r = _context20.sent;
            n = r.log;
            a = r.type;
            s = r.quality;
            o = r.dpi;
            _context20.next = 9;
            return K(r);
          case 9:
            i = _context20.sent;
            n.time("canvas to blob");
            _context20.next = 13;
            return ut(i, a, s);
          case 13:
            l = _context20.sent;
            if (!(["image/png", "image/jpeg"].includes(a) && o)) {
              _context20.next = 20;
              break;
            }
            _context20.next = 17;
            return mt(l.slice(0, 33));
          case 17:
            u = _context20.sent;
            _c2 = new Uint8Array(u);
            return _context20.abrupt("return", (a === "image/png" ? _c2 = ae(_c2, o) : a === "image/jpeg" && (_c2 = C(_c2, o)), n.timeEnd("canvas to blob"), new Blob([_c2, l.slice(33)], {
              type: a
            })));
          case 20:
            return _context20.abrupt("return", (n.timeEnd("canvas to blob"), l));
          case 21:
          case "end":
            return _context20.stop();
        }
      }, _callee19);
    }));
  }
  function B(e, t) {
    return E(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
      var r, n, a, s, o, i, l, _l$split, _l$split2, u, _c3, f, d, y, m, w, p, _b, _y, _g, S;
      return _regeneratorRuntime().wrap(function _callee20$(_context21) {
        while (1) switch (_context21.prev = _context21.next) {
          case 0:
            _context21.next = 2;
            return x(e, t);
          case 2:
            r = _context21.sent;
            n = r.log;
            a = r.quality;
            s = r.type;
            o = r.dpi;
            _context21.next = 9;
            return K(r);
          case 9:
            i = _context21.sent;
            n.time("canvas to data url");
            l = i.toDataURL(s, a);
            if (["image/png", "image/jpeg"].includes(s) && o && se && Xe) {
              _l$split = l.split(","), _l$split2 = _slicedToArray(_l$split, 2), u = _l$split2[0], _c3 = _l$split2[1];
              f = 0, d = !1;
              if (s === "image/png") {
                y = He(_c3);
                y >= 0 ? (f = Math.ceil((y + 28) / 3) * 4, d = !0) : f = 33 / 3 * 4;
              } else s === "image/jpeg" && (f = 18 / 3 * 4);
              m = _c3.substring(0, f), w = _c3.substring(f), p = window.atob(m), _b = new Uint8Array(p.length);
              for (_y = 0; _y < _b.length; _y++) _b[_y] = p.charCodeAt(_y);
              _g = s === "image/png" ? ae(_b, o, d) : C(_b, o), S = window.btoa(String.fromCharCode.apply(String, _toConsumableArray(_g)));
              l = [u, ",", S, w].join("");
            }
            return _context21.abrupt("return", (n.timeEnd("canvas to data url"), l));
          case 14:
          case "end":
            return _context21.stop();
        }
      }, _callee20);
    }));
  }
  function Fe(e, t) {
    return E(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
      var r, n, a, s, o, i, l;
      return _regeneratorRuntime().wrap(function _callee21$(_context22) {
        while (1) switch (_context22.prev = _context22.next) {
          case 0:
            _context22.next = 2;
            return x(e, t);
          case 2:
            r = _context22.sent;
            n = r.width;
            a = r.height;
            s = r.ownerDocument;
            _context22.next = 8;
            return B(r);
          case 8:
            o = _context22.sent;
            i = fe(n, a, s);
            l = i.ownerDocument.createElementNS(i.namespaceURI, "image");
            return _context22.abrupt("return", (l.setAttributeNS(null, "href", o), l.setAttributeNS(null, "height", "100%"), l.setAttributeNS(null, "width", "100%"), i.appendChild(l), de(i, r.isEnable("removeControlCharacter"))));
          case 12:
          case "end":
            return _context22.stop();
        }
      }, _callee21);
    }));
  }
  function Xt(e, t) {
    return E(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
      var r, n, a, s, o, i, l, u;
      return _regeneratorRuntime().wrap(function _callee22$(_context23) {
        while (1) switch (_context23.prev = _context23.next) {
          case 0:
            _context23.next = 2;
            return x(e, t);
          case 2:
            r = _context23.sent;
            n = r.ownerDocument;
            a = r.width;
            s = r.height;
            o = r.scale;
            i = r.type;
            if (!(i === "image/svg+xml")) {
              _context23.next = 14;
              break;
            }
            _context23.next = 11;
            return Fe(r);
          case 11:
            _context23.t0 = _context23.sent;
            _context23.next = 17;
            break;
          case 14:
            _context23.next = 16;
            return B(r);
          case 16:
            _context23.t0 = _context23.sent;
          case 17:
            l = _context23.t0;
            u = U(l, n);
            return _context23.abrupt("return", (u.width = Math.floor(a * o), u.height = Math.floor(s * o), u.style.width = "".concat(a, "px"), u.style.height = "".concat(s, "px"), u));
          case 20:
          case "end":
            return _context23.stop();
        }
      }, _callee22);
    }));
  }
  function Gt(e, t) {
    return E(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
      return _regeneratorRuntime().wrap(function _callee23$(_context24) {
        while (1) switch (_context24.prev = _context24.next) {
          case 0:
            _context24.t0 = B;
            _context24.next = 3;
            return x(e, L(D({}, t), {
              type: "image/jpeg"
            }));
          case 3:
            _context24.t1 = _context24.sent;
            return _context24.abrupt("return", (0, _context24.t0)(_context24.t1));
          case 5:
          case "end":
            return _context24.stop();
        }
      }, _callee23);
    }));
  }
  function Yt(e, t) {
    return E(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
      var r, n;
      return _regeneratorRuntime().wrap(function _callee24$(_context25) {
        while (1) switch (_context25.prev = _context25.next) {
          case 0:
            _context25.next = 2;
            return x(e, t);
          case 2:
            r = _context25.sent;
            _context25.next = 5;
            return K(r);
          case 5:
            n = _context25.sent;
            return _context25.abrupt("return", n.getContext("2d").getImageData(0, 0, n.width, n.height).data);
          case 7:
          case "end":
            return _context25.stop();
        }
      }, _callee24);
    }));
  }
  function Jt(e, t) {
    return E(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
      return _regeneratorRuntime().wrap(function _callee25$(_context26) {
        while (1) switch (_context26.prev = _context26.next) {
          case 0:
            _context26.t0 = B;
            _context26.next = 3;
            return x(e, L(D({}, t), {
              type: "image/png"
            }));
          case 3:
            _context26.t1 = _context26.sent;
            return _context26.abrupt("return", (0, _context26.t0)(_context26.t1));
          case 5:
          case "end":
            return _context26.stop();
        }
      }, _callee25);
    }));
  }
  function Kt(e, t) {
    return E(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
      return _regeneratorRuntime().wrap(function _callee26$(_context27) {
        while (1) switch (_context27.prev = _context27.next) {
          case 0:
            _context27.t0 = B;
            _context27.next = 3;
            return x(e, L(D({}, t), {
              type: "image/webp"
            }));
          case 3:
            _context27.t1 = _context27.sent;
            return _context27.abrupt("return", (0, _context27.t0)(_context27.t1));
          case 5:
          case "end":
            return _context27.stop();
        }
      }, _callee26);
    }));
  }
  h.createContext = pe, h.destroyContext = Ae, h.domToBlob = zt, h.domToCanvas = K, h.domToDataUrl = B, h.domToForeignObjectSvg = Pe, h.domToImage = Xt, h.domToJpeg = Gt, h.domToPixel = Yt, h.domToPng = Jt, h.domToSvg = Fe, h.domToWebp = Kt, h.loadMedia = $, h.waitUntilLoad = ge, Object.defineProperty(h, Symbol.toStringTag, {
    value: "Module"
  });
});